import {
  buildParameterizedUrl,
  hasValueForQueryParameter,
} from "@/components/AutoCompleteDisplay/components/helper";
import { DescriptionText } from "@/components/AutoCompleteDisplay/components/styled";
import { getUserIdForProjectLeaderRegion } from "@/components/DynamicForm/helper";
import { useDefaultDepartmentDocument } from "@/components/DynamicForm/hooks";
import { autoCompleteValueType } from "@/propTypes";
import { useProjectContext, useUserContext } from "@/providers";
import {
  useGetAdminFlatFormsQuery,
  useGetDynamicAutoCompleteQuery,
} from "@/services";
import { Row } from "antd";
import { string } from "prop-types";
import { useEffect, useState } from "react";

export const DepartmentAutoCompleteDisplay = ({ value, url }) => {
  const [parameterizedUrl, setParameterizedUrl] = useState();
  const [costCenterValue, setCostCenterValue] = useState();

  const { data: autoCompleteValue } = useGetDynamicAutoCompleteQuery(
    parameterizedUrl,
    {
      skip: !parameterizedUrl,
    }
  );

  const { project } = useProjectContext();

  const { userToken } = useUserContext();
  const { data: { flatForms } = {} } = useGetAdminFlatFormsQuery();

  const userId =
    getUserIdForProjectLeaderRegion(project.projectLeaders, flatForms) ||
    userToken.user.id;
  const defaultDepartmentDocument = useDefaultDepartmentDocument(userId);

  useEffect(() => {
    if (!url || !hasValueForQueryParameter(value)) return;

    setParameterizedUrl(buildParameterizedUrl(url, value));
  }, [url, value]);

  useEffect(() => {
    if (!autoCompleteValue) return;
    if (project?.costCenterTenantId) {
      // new logic, either use default or selected cost center.
      const filteredCostCenter = autoCompleteValue.filter(
        (value) =>
          value?.document?.tenantId === project.costCenterTenantId &&
          value?.document?.name === project.department
      );
      if (filteredCostCenter?.length === 0) {
        setCostCenterValue(defaultDepartmentDocument.costCenter);
      } else {
        setCostCenterValue(filteredCostCenter[0]?.document?.costCenter);
      }
    } else {
      // fall back on old logic.
      const nonTestValues = autoCompleteValue.filter(
        (value) => !value?.document?.costCenter?.toLowerCase().includes("test")
      );
      setCostCenterValue(nonTestValues[0]?.document?.costCenter);
    }
  }, [
    autoCompleteValue,
    defaultDepartmentDocument?.costCenter,
    defaultDepartmentDocument?.department,
    project,
  ]);

  return (
    <Row>
      <DescriptionText>{value}</DescriptionText>
      <DescriptionText className="block">{costCenterValue}</DescriptionText>
    </Row>
  );
};

DepartmentAutoCompleteDisplay.propTypes = {
  value: autoCompleteValueType.isRequired,
  url: string.isRequired,
};
